export { linkToDeleteAssignment } from "./routes/assignment/routes/delete/links";
export { linkToAssignmentPage } from "./routes/assignment/links";
export { linkToAssignmentStudentResult } from "./routes/assignment/routes/user/links";
